import Component from "vue-class-component";
import Vue from "Vue";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class Checkbox extends Vue {
	@Prop({ default: "" })
	public label;

	@Prop()
	public displayLabel = true;

	@Prop()
	private vmodel;

	@Prop()
	private dark = false;

	@Prop()
	private modeClick = false;

	@Prop()
	private toNumber = false;

	@Prop()
	private disabled = false;

	public isChecked = false;

	@Watch("vmodel", { immediate: true })
	public setState(): void {
		this.isChecked = this.vmodel;
	}

	public click(): void {
		if (this.disabled) {
			return;
		}

		this.$emit("changed");
		this.isChecked = !this.isChecked;

		if (!this.modeClick) {
			if (this.toNumber) {
				this.$emit("update:vmodel", Number(this.isChecked));
			} else {
				this.$emit("update:vmodel", this.isChecked);
			}
		} else {
			this.$emit("click");
		}
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/Checkbox/checkbox.ts